
/* styles */
require("!!vue-style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2dbdbf96&scoped=true!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PageForm.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PageForm.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2dbdbf96!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PageForm.vue"),
  /* scopeId */
  "data-v-2dbdbf96",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/page/partials/DemoLogin/PageForm.vue
// module id = 617
// module chunks = 0